import type { S3Level } from '@admiin-com/ds-common';
import { WBS3Avatar } from '@admiin-com/ds-amplify-web';
import { WBFlex, WBIcon, WBTypography } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import React from 'react';

export const AvatarMenu = ({
  showName,
  name,
  isFirm,
  onClick,
  logo,
}: {
  showName?: boolean;
  name?: string;
  isFirm?: boolean;
  onClick?: () => void;
  logo?: {
    key?: string | null;
    identityId?: string | null;
    level?: S3Level | null;
  } | null;
}) => {
  const userName = name || '';
  return (
    <Button onClick={onClick} isFirm={isFirm}>
      <WBS3Avatar
        sx={{
          borderRadius: '50%',
          width: { xs: '40px', md: '40px' },
          height: { xs: '40px', md: '40px' },
        }}
        imgKey={logo?.key || undefined}
        identityId={logo?.identityId || undefined}
        level={logo?.level ?? undefined}
        companyName={userName}
        fontSize="h4.fontSize"
      />
      {showName ? (
        <WBFlex alignItems={'center'}>
          <WBTypography
            ml={1}
            mr={2}
            fontWeight={700}
            color="text.primary"
            noWrap
          >
            {userName}
          </WBTypography>
          {!isFirm && <WBIcon name="ChevronDown" size={'small'} />}
        </WBFlex>
      ) : null}
    </Button>
  );
};

const Button = styled(WBFlex)<{ isFirm?: boolean }>(({ theme, isFirm }) => ({
  padding: theme.spacing(1, 1),
  borderRadius: theme.shape.borderRadius,
  cursor: isFirm ? 'default' : 'pointer',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0),
  },
}));
